import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchRentalHistory } from './queries/useFetchRentalHistory'

const RentalHistoryPage = () => {
	const { t } = useTranslation()
	const { rentalHistory, isRentalHistoryLoading } = useFetchRentalHistory()

	return (
		<>
			<Header title={t('Rental / History')} />
			<HistoryTable results={rentalHistory?.data} isLoading={isRentalHistoryLoading} />
		</>
	)
}

export default RentalHistoryPage
